import { FiTrendingUp, FiTrendingDown, FiMinus } from "react-icons/fi";

// Static data for assessment scores
export const staticData = {
	confidenceScore: 85,
	confidenceCategory: "Very confident",
	accessibilityScore: 75,
	accessibilityCategory: "Good"
};

// Rating categories
export const ratingCategories = [
	{ tag: 'efficacy', label: 'Efficacy' },
	{ tag: 'safety', label: 'Safety' },
	{ tag: 'tolerability', label: 'Tolerability' },
	{ tag: 'adherence', label: 'Adherence' },
	{ tag: 'priceandaffordability', label: 'Price/Affordability' }
];

// Peer averages data (simulated - would come from API)
export const peerAverages = {
	efficacy: 3.8,
	safety: 4.2,
	tolerability: 3.5,
	adherence: 3.9,
	priceandaffordability: 3.2
};

// Peer averages for accessibility and confidence (percentage based)
export const peerAccessibilityAvg = 70;
export const peerConfidenceAvg = 78;

// Get peer comparison status for rating-based values (1-5 scale)
export const getPeerComparisonStatus = (rating, peerAvg) => {
	const diff = rating - peerAvg;
	if (diff > 0.3) {
		return { label: 'Above peer avg', color: 'text-emerald-700', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-200', icon: FiTrendingUp };
	} else if (diff < -0.3) {
		return { label: 'Below peer avg', color: 'text-amber-700', bgColor: 'bg-amber-50', borderColor: 'border-amber-200', icon: FiTrendingDown };
	} else {
		return { label: 'At peer avg', color: 'text-blue-700', bgColor: 'bg-blue-50', borderColor: 'border-blue-200', icon: FiMinus };
	}
};

// Get peer comparison status for percentage scores
export const getPeerComparisonStatusPercent = (score, peerAvg) => {
	const diff = score - peerAvg;
	if (diff > 5) {
		return { label: 'Above peer avg', color: 'text-emerald-700', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-200', icon: FiTrendingUp };
	} else if (diff < -5) {
		return { label: 'Below peer avg', color: 'text-amber-700', bgColor: 'bg-amber-50', borderColor: 'border-amber-200', icon: FiTrendingDown };
	} else {
		return { label: 'At peer avg', color: 'text-blue-700', bgColor: 'bg-blue-50', borderColor: 'border-blue-200', icon: FiMinus };
	}
};

// Get dynamic color based on rating value
export const getRatingColor = (roundedRating) => {
	if (roundedRating === 5) {
		return "#059669"; // Dark green for 5
	} else if (roundedRating >= 3 && roundedRating <= 4) {
		return "#1E5EFF"; // Blue for 3-4
	} else if (roundedRating >= 1 && roundedRating <= 2) {
		return "#F59E0B"; // Orange for 1-2
	} else {
		return "#8B5CF6"; // Default purple
	}
};
